import { cn } from "@/libraries/cn";
import SearchIcon from "@mui/icons-material/Search";
import { forwardRef } from "react";

interface SearchInputProps extends React.ComponentProps<"input"> {
	label: string;
}

const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
	(props, ref) => {
		const { className, ...inpuProps } = props;
		return (
			<fieldset className="w-full px-4 flex flex-row justify-center items-center gap-4 border border-zinc-500 rounded-xl">
				<label htmlFor={inpuProps.name ?? inpuProps.id} className="hidden">
					Search
				</label>
				<SearchIcon />
				<input
					ref={ref}
					type="text"
					className={cn("appearance-none w-full h-14 outline-none", className)}
					{...inpuProps}
				/>
			</fieldset>
		);
	},
);

export default SearchInput;
